import classNames from 'classnames'
import React, { FC, useState } from 'react'
import { Grid } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { Trans, t } from '@lingui/macro'

import IconFolder from '../../components/common/icon/IconFolder'
import Loader from '../../components/common/loader/Loader'
import PageHeader from '../../components/common/page/header/PageHeader'
import { ButtonOutline, ButtonPrimary } from 'front-end/src/components'

import { CertificationManageCard } from './components/CertificationManageCard'
import { linkBuilder, staticLinks } from 'shared/linkBuilder'
import { navigateTo } from '../../app/util/appHistory'
import { NewCertificationModal } from './modals/NewCertificationModal'
import { Page } from '../../components/common/page/Page'
import { useManageCertificationsPageQuery } from './ManageCertificationsPage.codegen'

import './ManageCertificationsPage.less'
import IconEmptyCertifications from 'public/assets/img/empty-certifications.svg'
import { IconPlus } from 'front-end/src/components/common/icon/IconPlus'

export const ManageCertificationsPage: FC = () => {
  const [showCreateModal, setShowCreateModal] = useState(false)

  const { data, refetch, loading } = useManageCertificationsPageQuery()
  const certifications = data?.admin?.certifications

  return (
    <Page
      className={classNames('Certifications', {
        'Certifications--empty': !certifications?.length,
        'Certifications--list': certifications?.length
      })}
    >
      {loading && <Loader />}
      {Array.isArray(certifications) && (
        <>
          <PageHeader
            className="PageHeader"
            title={t`Manage certifications`}
            controls={
              <>
                <ButtonOutline
                  onClick={() =>
                    navigateTo(staticLinks.certificationsTemplates)
                  }
                  leftIcon={<IconFolder />}
                >
                  <Trans>Manage templates</Trans>
                </ButtonOutline>
                <ButtonPrimary
                  onClick={() => {
                    setShowCreateModal(true)
                  }}
                  dataTest="NewCertificationButton"
                  leftIcon={<IconPlus />}
                >
                  <Trans>New certification</Trans>
                </ButtonPrimary>
              </>
            }
          />
          {certifications.length ? (
            <Grid templateColumns={['repeat(1, 1fr)']} gap={0}>
              {certifications.map((certification) => (
                <Link
                  key={certification.id}
                  to={linkBuilder.certificationsManage(certification.id)}
                >
                  <CertificationManageCard certification={certification} />
                </Link>
              ))}
            </Grid>
          ) : (
            <div className="Certifications__empty no-items">
              <img
                className="more-right"
                src={IconEmptyCertifications}
                alt={t`Create a new certification`}
              />
              <h2>
                <Trans>Create a new certification</Trans>
              </h2>
              <p>
                <Trans>
                  Certification is awarded for users based
                  <br />
                  on any number of resources, pathways and events.
                </Trans>
              </p>
            </div>
          )}
        </>
      )}

      {showCreateModal && (
        <NewCertificationModal
          onHide={() => {
            setShowCreateModal(false)
            refetch()
          }}
        />
      )}
    </Page>
  )
}
